export const platforms = [
  {
    id: 1,
    name: '红桃视频',
    slug: 'hongtao-video',
    description: '海量高清影视资源，每日更新热门电影电视剧，支持多线路播放，流畅不卡顿，观影体验一流。',
    logo: 'https://readdy.ai/api/search-image?query=Simple%20warm%20red%20peach%20shaped%20logo%20icon%20on%20light%20cream%20background%2C%20minimalist%20flat%20design%2C%20modern%20Chinese%20video%20platform%20branding%2C%20clean%20and%20professional%20look&width=200&height=200&seq=platform-hongtao&orientation=squarish',
    rating: 4.8,
    users: '1200万+',
    tags: ['高清影视', '每日更新', '多线路'],
    featured: true,
  },
  {
    id: 2,
    name: '红杏视频',
    slug: 'hongxing-video',
    description: '专注于精品影视内容，涵盖电影、电视剧、综艺、动漫等全品类资源，界面简洁易用。',
    logo: 'https://readdy.ai/api/search-image?query=Minimalist%20apricot%20colored%20play%20button%20logo%20on%20warm%20white%20background%2C%20clean%20geometric%20design%2C%20modern%20video%20streaming%20platform%20identity%2C%20simple%20and%20elegant%20style&width=200&height=200&seq=platform-hongxing&orientation=squarish',
    rating: 4.7,
    users: '980万+',
    tags: ['全品类', '界面简洁', '精品内容'],
    featured: true,
  },
  {
    id: 3,
    name: '樱花影视',
    slug: 'yinghua-video',
    description: '最新最热的日韩影视资源平台，同步更新热门剧集，提供原声中文字幕，追剧首选。',
    logo: 'https://readdy.ai/api/search-image?query=Soft%20pink%20cherry%20blossom%20inspired%20minimalist%20logo%20on%20cream%20background%2C%20simple%20flat%20design%2C%20modern%20Asian%20streaming%20platform%20brand%2C%20elegant%20and%20refined%20aesthetic&width=200&height=200&seq=platform-yinghua&orientation=squarish',
    rating: 4.6,
    users: '860万+',
    tags: ['日韩剧集', '原声字幕', '同步更新'],
    featured: false,
  },
  {
    id: 4,
    name: '星辰影院',
    slug: 'xingchen-cinema',
    description: '国内院线大片第一时间上线，支持4K超清画质播放，家庭影院级观影享受。',
    logo: 'https://readdy.ai/api/search-image?query=Golden%20star%20shaped%20minimalist%20logo%20icon%20on%20light%20warm%20background%2C%20modern%20cinema%20branding%20design%2C%20clean%20geometric%20style%2C%20professional%20movie%20platform%20identity&width=200&height=200&seq=platform-xingchen&orientation=squarish',
    rating: 4.5,
    users: '750万+',
    tags: ['院线大片', '4K超清', '家庭影院'],
    featured: false,
  },
  {
    id: 5,
    name: '蓝鲸视频',
    slug: 'lanjing-video',
    description: '海量蓝光资源库，专注提供高品质影视内容，支持离线缓存，随时随地享受观影乐趣。',
    logo: 'https://readdy.ai/api/search-image?query=Minimalist%20blue%20whale%20tail%20inspired%20abstract%20logo%20on%20warm%20cream%20background%2C%20simple%20geometric%20design%2C%20modern%20streaming%20service%20brand%2C%20clean%20professional%20look&width=200&height=200&seq=platform-lanjing&orientation=squarish',
    rating: 4.4,
    users: '620万+',
    tags: ['蓝光资源', '离线缓存', '高品质'],
    featured: false,
  },
  {
    id: 6,
    name: '飞鱼追剧',
    slug: 'feiyu-drama',
    description: '追剧爱好者的天堂，热门国产剧、韩剧、美剧一网打尽，更新速度全网领先。',
    logo: 'https://readdy.ai/api/search-image?query=Flying%20fish%20inspired%20simple%20abstract%20logo%20on%20light%20warm%20background%2C%20minimalist%20flat%20design%2C%20modern%20drama%20streaming%20platform%20brand%2C%20dynamic%20and%20clean%20identity&width=200&height=200&seq=platform-feiyu&orientation=squarish',
    rating: 4.3,
    users: '580万+',
    tags: ['追剧神器', '更新快', '多语种'],
    featured: false,
  },
];

export const categories = [
  { id: 1, name: '电影', slug: 'movies', icon: 'ri-film-line', count: 5280 },
  { id: 2, name: '电视剧', slug: 'tv-series', icon: 'ri-tv-line', count: 3620 },
  { id: 3, name: '综艺', slug: 'variety', icon: 'ri-emotion-laugh-line', count: 1840 },
  { id: 4, name: '动漫', slug: 'anime', icon: 'ri-rocket-line', count: 2560 },
  { id: 5, name: '纪录片', slug: 'documentary', icon: 'ri-camera-lens-line', count: 980 },
  { id: 6, name: '少儿', slug: 'kids', icon: 'ri-bear-smile-line', count: 720 },
];

export const hotMovies = [
  {
    id: 1,
    title: '流浪地球3',
    category: 'movies',
    categoryName: '电影',
    rating: 9.2,
    year: 2026,
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20with%20astronaut%20and%20glowing%20Earth%20from%20space%2C%20dramatic%20warm%20lighting%2C%20modern%20Chinese%20blockbuster%20film%20poster%20design%2C%20epic%20scale%20cinematography%2C%20professional%20movie%20advertising%20art&width=400&height=560&seq=movie-wandering-earth-3&orientation=portrait',
    description: '人类命运共同体面对新的宇宙挑战，团结一致开启新征程。',
    tags: ['科幻', '冒险', '国产'],
  },
  {
    id: 2,
    title: '繁花似锦',
    category: 'tv-series',
    categoryName: '电视剧',
    rating: 8.9,
    year: 2026,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20period%20drama%20poster%20with%20traditional%20elements%20and%20flowers%2C%20warm%20golden%20lighting%2C%20artistic%20Chinese%20TV%20series%20advertising%20design%2C%20refined%20and%20nostalgic%20style&width=400&height=560&seq=movie-fanhua&orientation=portrait',
    description: '上海滩风云变幻，一段跨越三十年的爱恨情仇史诗巨制。',
    tags: ['年代', '爱情', '剧情'],
  },
  {
    id: 3,
    title: '封神第二部',
    category: 'movies',
    categoryName: '电影',
    rating: 8.8,
    year: 2026,
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20fantasy%20movie%20poster%20with%20ancient%20warriors%20and%20mystical%20elements%2C%20dramatic%20composition%2C%20warm%20golden%20tones%2C%20Chinese%20blockbuster%20film%20advertising%20design&width=400&height=560&seq=movie-fengshen-2&orientation=portrait',
    description: '神话史诗再续传奇，封神大战震撼来袭。',
    tags: ['神话', '奇幻', '动作'],
  },
  {
    id: 4,
    title: '长安十二时辰2',
    category: 'tv-series',
    categoryName: '电视剧',
    rating: 8.7,
    year: 2026,
    image: 'https://readdy.ai/api/search-image?query=Tang%20dynasty%20Chinese%20historical%20thriller%20TV%20drama%20poster%20with%20ancient%20city%20and%20lanterns%2C%20warm%20atmospheric%20lighting%2C%20cinematic%20Chinese%20series%20advertising%20art&width=400&height=560&seq=movie-changan&orientation=portrait',
    description: '古都长安暗流涌动，十二时辰内化解惊天危机。',
    tags: ['古装', '悬疑', '历史'],
  },
  {
    id: 5,
    title: '哪吒之魔童闹海2',
    category: 'anime',
    categoryName: '动漫',
    rating: 9.1,
    year: 2026,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20fantasy%20film%20poster%20with%20mythological%20hero%20character%20and%20magical%20elements%2C%20vibrant%20warm%20colors%2C%20modern%20Chinese%20animation%20movie%20advertising%20design&width=400&height=560&seq=movie-nezha-2&orientation=portrait',
    description: '哪吒再战四海，国产动画巅峰之作重磅回归。',
    tags: ['动画', '神话', '动作'],
  },
  {
    id: 6,
    title: '奔跑吧第12季',
    category: 'variety',
    categoryName: '综艺',
    rating: 8.3,
    year: 2026,
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20Chinese%20variety%20show%20poster%20with%20energetic%20celebrities%20running%2C%20bright%20warm%20colors%2C%20fun%20and%20vibrant%20Chinese%20TV%20show%20advertising%20design&width=400&height=560&seq=movie-running&orientation=portrait',
    description: '全新阵容集结，欢乐奔跑，笑料不断精彩纷呈。',
    tags: ['真人秀', '竞技', '搞笑'],
  },
  {
    id: 7,
    title: '狂飙2',
    category: 'tv-series',
    categoryName: '电视剧',
    rating: 9.0,
    year: 2026,
    image: 'https://readdy.ai/api/search-image?query=Intense%20Chinese%20crime%20thriller%20TV%20drama%20poster%20with%20dark%20atmosphere%20and%20police%20theme%2C%20dramatic%20warm%20lighting%2C%20modern%20Chinese%20series%20advertising%20art&width=400&height=560&seq=movie-kuangbiao-2&orientation=portrait',
    description: '扫黑除恶再出击，正义与邪恶的终极较量。',
    tags: ['刑侦', '悬疑', '剧情'],
  },
  {
    id: 8,
    title: '地球脉动III',
    category: 'documentary',
    categoryName: '纪录片',
    rating: 9.5,
    year: 2026,
    image: 'https://readdy.ai/api/search-image?query=Stunning%20nature%20documentary%20poster%20with%20diverse%20wildlife%20and%20beautiful%20landscapes%2C%20warm%20natural%20lighting%2C%20professional%20BBC-style%20nature%20film%20advertising%20design&width=400&height=560&seq=movie-earth-3&orientation=portrait',
    description: '探索地球最震撼的自然奇观，感受生命之美。',
    tags: ['自然', '生态', 'BBC'],
  },
];

export const features = [
  {
    id: 1,
    title: '高清画质',
    description: '支持1080P至4K超清画质播放，根据网络状况智能适配，带来极致观影体验。',
    icon: 'ri-4k-line',
  },
  {
    id: 2,
    title: '流畅不卡顿',
    description: '多CDN加速节点覆盖全国，智能切换最优线路，确保视频播放流畅不缓冲。',
    icon: 'ri-speed-up-line',
  },
  {
    id: 3,
    title: '海量资源',
    description: '汇聚全网优质影视资源，涵盖电影、电视剧、综艺、动漫等全品类内容。',
    icon: 'ri-database-2-line',
  },
  {
    id: 4,
    title: '每日更新',
    description: '专业团队24小时不间断更新，最新最热的影视内容第一时间上线。',
    icon: 'ri-calendar-check-line',
  },
];

export const testimonials = [
  {
    id: 1,
    name: '张先生',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20avatar%20on%20simple%20warm%20background%2C%20friendly%20smile%2C%20modern%20corporate%20headshot%20style&width=100&height=100&seq=avatar-zhang&orientation=squarish',
    comment: '茄子视频推荐的平台太靠谱了！之前找资源要翻好几个网站，现在一站式搞定，画质还高清，强烈推荐！',
    rating: 5,
  },
  {
    id: 2,
    name: '李女士',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20avatar%20on%20simple%20warm%20background%2C%20gentle%20smile%2C%20modern%20corporate%20headshot%20style&width=100&height=100&seq=avatar-li&orientation=squarish',
    comment: '作为追剧达人，茄子视频简直就是我的快乐源泉。分类清晰，更新又快，再也不用到处找资源了。',
    rating: 5,
  },
  {
    id: 3,
    name: '王同学',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20student%20portrait%20avatar%20on%20simple%20warm%20background%2C%20bright%20smile%2C%20casual%20modern%20headshot%20style&width=100&height=100&seq=avatar-wang&orientation=squarish',
    comment: '寝室里大家都用茄子视频找片看，资源全、不卡顿，周末电影之夜必备神器！',
    rating: 5,
  },
];

export const latestArticles = [
  {
    id: 1,
    title: '2026年最值得期待的十部国产大片',
    slug: '2026-top-10-chinese-movies',
    excerpt: '今年国产电影市场佳作频出，我们为大家精选了十部不容错过的国产大片，涵盖科幻、动作、剧情等多种类型。',
    category: 'movies',
    categoryName: '电影',
    date: '2026-07-28',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20collage%20with%20Chinese%20film%20elements%20and%20warm%20theater%20lighting%2C%20artistic%20composition%2C%20professional%20film%20blog%20header%20image%20design&width=600&height=400&seq=article-movies-2026&orientation=landscape',
  },
  {
    id: 2,
    title: '如何选择适合自己的视频平台？全面对比评测',
    slug: 'how-to-choose-video-platform',
    excerpt: '面对众多视频平台不知所措？我们从画质、资源量、更新速度、用户体验四个维度全方位对比主流平台。',
    category: 'guide',
    categoryName: '指南',
    date: '2026-07-25',
    image: 'https://readdy.ai/api/search-image?query=Modern%20technology%20comparison%20concept%20with%20multiple%20device%20screens%20showing%20video%20content%2C%20warm%20studio%20lighting%2C%20professional%20tech%20blog%20header%20design&width=600&height=400&seq=article-compare&orientation=landscape',
  },
  {
    id: 3,
    title: '追剧党必看：下半年热门电视剧追剧日历',
    slug: '2026-drama-schedule',
    excerpt: '整理了下半年即将上线的热门电视剧播出时间表，追剧党们赶紧收藏起来，再也不用担心错过更新。',
    category: 'tv-series',
    categoryName: '电视剧',
    date: '2026-07-22',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20TV%20drama%20calendar%20concept%20with%20warm%20cozy%20viewing%20setup%2C%20soft%20ambient%20lighting%2C%20lifestyle%20blog%20header%20image%20design&width=600&height=400&seq=article-drama-cal&orientation=landscape',
  },
];